var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClear = function SvgClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "clear_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#clear_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 1.666a8.326 8.326 0 0 0-8.333 8.333A8.326 8.326 0 0 0 10 18.333a8.326 8.326 0 0 0 8.334-8.334A8.326 8.326 0 0 0 10 1.666Zm3.584 11.917a.83.83 0 0 1-1.175 0L10 11.174l-2.408 2.409a.83.83 0 1 1-1.175-1.175l2.408-2.409-2.408-2.408a.83.83 0 1 1 1.175-1.175L10 8.824l2.409-2.408a.83.83 0 1 1 1.175 1.175l-2.409 2.408 2.409 2.409a.846.846 0 0 1 0 1.175Z",
    fill: "#3ABCA8"
  }))));
};
export default SvgClear;